import { Rol } from './roles.model';

// Funcion que devuelve si el rol es responsable de la empresa
export function esResponsable(rol: Rol): boolean {
  // Titular, Representante Legal, Apoderado, Adminsitrativo responsable, Reprpesentante
  return [1, 2, 3, 4, 5].includes(rol.tipo_rol_id);
}
